import { useEffect, useState } from "react";

const BASE_GAP = 20;

/**
 * Mobile-only shortcut back to the top of long pages.
 * Appears once the reader is a screen or so down the page, and lifts itself
 * off the footer so it never sits on top of the copyright line.
 */
export default function BackToTop() {
  const [visible, setVisible] = useState(false);
  const [bottomGap, setBottomGap] = useState(BASE_GAP);

  useEffect(() => {
    const measure = () => {
      setVisible(window.scrollY > 640);

      const footer = document.querySelector("footer");
      if (!footer) {
        setBottomGap(BASE_GAP);
        return;
      }

      const footerTop = footer.getBoundingClientRect().top;
      const overlap = Math.max(0, window.innerHeight - footerTop);
      /* Ride just above the footer, but never let the button climb so far
         that it floats into the middle of the screen. */
      const ceiling = window.innerHeight * 0.45;
      setBottomGap(Math.min(BASE_GAP + overlap, Math.max(BASE_GAP, ceiling)));
    };

    measure();
    window.addEventListener("scroll", measure, { passive: true });
    window.addEventListener("resize", measure);
    return () => {
      window.removeEventListener("scroll", measure);
      window.removeEventListener("resize", measure);
    };
  }, []);

  const scrollUp = () => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: 0, behavior: reduced ? "auto" : "smooth" });
  };

  return (
    <button
      type="button"
      onClick={scrollUp}
      aria-label="Back to top"
      style={{ bottom: `${bottomGap}px` }}
      className={`lg:hidden fixed right-4 z-40 w-11 h-11 flex items-center justify-center border-2 border-foreground-950 bg-foreground-950 text-primary-500 cursor-pointer transition-[opacity,transform] duration-300 ease-out ${
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-3 pointer-events-none"
      }`}
    >
      <i className="ri-arrow-up-line text-xl"></i>
    </button>
  );
}